import { FC, useRef } from 'react';
import { useRenderPosition } from '../../../../hooks/useRenderPosition';
import { DropdownOptions } from '../../../style';

type SingleSelectDropdownOptionsProps = {
  options: JSX.Element[];
  filterHeight: number;
};

const SingleSelectDropdownOptions: FC<SingleSelectDropdownOptionsProps> = ({
  options,
  filterHeight,
}) => {
  const optionWrapperRef = useRef<HTMLElement>(null);
  const renderPosition = useRenderPosition(optionWrapperRef);
  return (
    <DropdownOptions
      ref={optionWrapperRef as any}
      dynamicRender={true}
      filterHeight={filterHeight}
      renderPosition={renderPosition}
    >
      {options}
    </DropdownOptions>
  );
};

export default SingleSelectDropdownOptions;
